import { useEvolucoesAlergiaModalLazyQuery } from 'graphql/hooks.generated'
import React, { useState } from 'react'
import { Alergia } from 'view/atendimentos/detail/soap/aside/types/AlergiaModel'

import { MainDetailAccordion } from '../../MainDetailAccordion'
import { BodyAlergiaModal } from '../alergias/BodyAlergiaModal'
import { HeaderAlergiaModal } from '../alergias/HeaderAlergiaModal'

interface AccordionAlergiasModalProps {
  alergias: Alergia[]
}

export function AccordionAlergiasModal(props: AccordionAlergiasModalProps) {
  const { alergias } = props
  const [alergiaLoadingEvolucoes, setAlergiaLoadingEvolucoes] = useState<string>()

  const [executeQuery, { data, loading }] = useEvolucoesAlergiaModalLazyQuery({
    fetchPolicy: 'cache-and-network',
  })

  const alergiaQueryResult = !isNaN(+alergiaLoadingEvolucoes) ? data?.alergia : null

  const handleChange = (alergiaUUID: string[]) => {
    const alergiaId = alergiaUUID?.join()
    if (!!alergiaId) {
      setAlergiaLoadingEvolucoes(alergiaId)
      !isNaN(+alergiaId) && executeQuery({ variables: { alergiaId: alergiaId } })
    }
  }

  const evolucoes = [
    ...(alergias.find((alergia) => alergia.id === alergiaLoadingEvolucoes)?.evolucoes ?? []),
    ...(alergiaQueryResult?.evolucoes?.sort(
      (a, b) => (b.atualizadoEm ?? Date.now()) - (a.atualizadoEm ?? Date.now())
    ) ?? []),
  ]

  return (
    <MainDetailAccordion
      type='alergia'
      loading={loading}
      listOf={alergias}
      evolucoes={evolucoes}
      header={<HeaderAlergiaModal />}
      body={<BodyAlergiaModal />}
      onChange={handleChange}
    />
  )
}
